import React from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";


export default function TradingFees() {
    return (
      <>
      <Header />
            <Footer />
          </>
        );
      }
      